/**
 * WordPress dependencies
 */
import { createSlotFill } from '@wordpress/components';

const CommentIconToolbarSlotFill = createSlotFill(
	Symbol( 'CommentIconToolbarSlotFill' )
);

export default CommentIconToolbarSlotFill;
